/**
 * `accessMatrix` translations, for every locale -- the Users page's access
 * levels table: levels as columns, permissions as rows.
 */
export const accessMatrix = {
  mn: {
    accessMatrix: {
      permission: 'Эрх',
      base: 'Үндсэн хандалт',
      saved: '{{level}}: хадгалагдлаа',
      toggle: '{{ability}}: {{level}}',
      ownLevel: 'Өөрийн эзэмшдэг түвшинг өөрчлөх боломжгүй',
      fixedAbility: 'Энэ эрх зөвхөн өөрийн түвшинд хамаарна',
      renameOrDelete: '{{name}} түвшний нэрийг өөрчлөх эсвэл устгах',
      noLevels: 'Хандалтын түвшин алга',
      levelsLoadFailed: 'Хандалтын түвшнүүдийг ачаалж чадсангүй',
      abilitiesLoadFailed: 'Эрхийн жагсаалтыг ачаалж чадсангүй',
      orgCopy: 'Зассан хуулбар',
      orgCopyLabel: '{{name}}: зассан хуулбар',
      orgCopyHelp: 'Энэ нь үндсэн түвшний танай байгууллагын зассан хуулбар. Хуулбарыг устгавал үндсэн түвшин сэргэнэ.',
      restoreBuiltin: 'Үндсэн түвшнийг сэргээх',
      restoreConfirm: '«{{name}}» түвшний танай байгууллагын хуулбарыг устгах уу? Үндсэн түвшин дахин үйлчилж, энэ түвшний {{n}} хэрэглэгчид үндсэн эрхүүдийг авна.',
      restored: '{{name}}: үндсэн түвшин сэргээгдлээ',
      restoreFailed: '«{{name}}» түвшний үндсэн хувилбарыг сэргээж чадсангүй.',
    },
  },
  en: {
    accessMatrix: {
      permission: 'Permission',
      base: 'Basic access',
      saved: '{{level}}: saved',
      toggle: '{{ability}}: {{level}}',
      ownLevel: 'You cannot change the level you hold',
      fixedAbility: 'This permission is fixed to its own level',
      renameOrDelete: 'Rename or delete {{name}}',
      noLevels: 'No access levels',
      levelsLoadFailed: 'Could not load the access levels',
      abilitiesLoadFailed: 'Could not load the permission list',
      orgCopy: 'Edited copy',
      orgCopyLabel: '{{name}}: edited copy',
      orgCopyHelp: 'Your organization’s edited copy of this built-in level. Deleting the copy restores the built-in.',
      restoreBuiltin: 'Delete copy, restore built-in',
      restoreConfirm: 'Delete your organization’s copy of “{{name}}”? The built-in level applies again, and the {{n}} user(s) on it get the built-in permissions.',
      restored: '{{name}}: built-in restored',
      restoreFailed: 'Could not restore the built-in level “{{name}}”.',
    },
  },
  ru: {
    accessMatrix: {
      permission: 'Право',
      base: 'Базовый доступ',
      saved: '{{level}}: сохранено',
      toggle: '{{ability}}: {{level}}',
      ownLevel: 'Нельзя менять уровень, который у вас самих',
      fixedAbility: 'Это право закреплено за своим уровнем',
      renameOrDelete: 'Переименовать или удалить уровень {{name}}',
      noLevels: 'Уровней доступа нет',
      levelsLoadFailed: 'Не удалось загрузить уровни доступа',
      abilitiesLoadFailed: 'Не удалось загрузить список прав',
      orgCopy: 'Изменённая копия',
      orgCopyLabel: '{{name}}: изменённая копия',
      orgCopyHelp: 'Изменённая копия этого встроенного уровня для вашей организации. Удаление копии восстанавливает встроенный уровень.',
      restoreBuiltin: 'Восстановить встроенный',
      restoreConfirm: 'Удалить копию уровня «{{name}}» вашей организации? Снова будет действовать встроенный уровень, и пользователи на нём ({{n}}) получат встроенные права.',
      restored: '{{name}}: встроенный уровень восстановлен',
      restoreFailed: 'Не удалось восстановить встроенный уровень «{{name}}».',
    },
  },
}
